import { Invoices } from '@/features/invoices/Invoices.tsx';
import { SearchPaginationContextProvider } from '@arsnovasystems/ars-front-lib';

/**
 * Wraps the invoices view with the search and pagination context
 * required by the invoices feature.
 *
 * @returns The invoices page wrapped in a
 *  `SearchPaginationContextProvider`.
 */
export const InvoicesContainer = () => {
  return (
    <SearchPaginationContextProvider>
      <Invoices />
    </SearchPaginationContextProvider>
  );
};
